/* PS AFEX S3 Texture Control — section glow follows interactive dial */
(function () {
  if (window.__PS_AFEX_S3__) return;
  window.__PS_AFEX_S3__ = true;

  function playTick(a, b, c, d) {
    if (window.PS_AFEX && window.PS_AFEX.playTick) window.PS_AFEX.playTick(a, b, c, d);
  }

  function init() {
    var section = document.getElementById('ps-afex-texture');
    var dialHit = document.getElementById('dial-hit');
    if (!section || !dialHit) return;

    var accents = (window.PS_AFEX_TEXTURE && window.PS_AFEX_TEXTURE.accents) || [
      '#4aa3ff', '#7ee08b', '#ffd24a', '#FF6A00'
    ];
    var textureIndex = -1;

    function setBackground(i) {
      var idx = ((i % accents.length) + accents.length) % accents.length;
      if (idx === textureIndex) return;
      textureIndex = idx;
      section.style.background =
        'radial-gradient(ellipse at 50% 42%, ' + accents[idx] + '20 0%, #fff8f2 42%, #ffffff 68%)';
    }

    var dialObserver = new MutationObserver(function () {
      var idx = parseInt(dialHit.getAttribute('aria-valuenow'), 10);
      if (isNaN(idx)) return;
      playTick(400 + idx * 40, 0.09, 'triangle', 0.05);
      setBackground(idx);
    });
    dialObserver.observe(dialHit, { attributes: true, attributeFilter: ['aria-valuenow'] });

    setBackground(parseInt(dialHit.getAttribute('aria-valuenow'), 10) || 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
